const FlightMatrixApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/flight-matrix/get`,
  POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/flight-matrix/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/flight-matrix/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/flight-matrix/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/flight-matrix/download`
};

export default FlightMatrixApiUrls
